export const DobBannerErrorMessageMessages = {
  validationErrorMessage: {
    id: 'Pages.ConsumerDob.Form.validationErrorMessage',
    description: 'An unforeseen error'
  }
}
